import ReturnsPolicyTemplate from './RefundTemplate';
import type { RefundPolicyData } from './RefundPolicy';
import BottomDrawer from '~/modules/detail/components/bottom-drawer/BottomDrawer';
import { Caption } from '@archipro-design/aria';

const RefundPolicyDialogMobile = ({
    open,
    close,
    data,
}: {
    open: boolean;
    close: () => void;
    data: RefundPolicyData;
}) => {
    return (
        <BottomDrawer
            open={open}
            toggleModal={close}
            title={<Caption variant="01">Return and Refund policy</Caption>}
        >
            <ReturnsPolicyTemplate data={data} />
        </BottomDrawer>
    );
};

export default RefundPolicyDialogMobile;
